import React, { useEffect, useState } from 'react';
import logo from '../../../../Assets/Images/logo.png';
import { useDispatch } from 'react-redux';
import { loginFn } from '../../../../module/action/auth';
import { useNavigate } from 'react-router-dom';
import { getCookie } from '../../../../api/utils';

function Login() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const onSubmit = ev => {
    ev.preventDefault();
    dispatch(
      loginFn(
        {
          email,
          password,
        },
        () => {
          window.location.reload();
          navigate('/');
          setEmail('');
          setPassword('');
        }
      )
    );
  };
  useEffect(() => {
    let token = getCookie('token');
    if (token) {
      navigate('/');
    }
  }, []);
  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} alt="User Icon" />
        <h1>Login</h1>
        <form id="login-form" onSubmit={onSubmit}>
          <div className="input-container">
            <input
              type="text"
              id="username"
              value={email}
              onChange={ev => setEmail(ev.target.value)}
              placeholder="username"
              required
            />
          </div>
          <div className="input-container">
            <input
              type="password"
              id="password"
              placeholder="password"
              required
              value={password}
              onChange={ev => setPassword(ev.target.value)}
            />
          </div>
          <button type="submit">Login →</button>
        </form>
        <div className="extra-options"></div>
      </div>
    </div>
  );
}

export default Login;
